import { Drawer } from 'antd'

import { drawerAndModalWidth } from '../../../../../util/guideline'
import { CreateMaturityCompliance } from './CreateMaturityComplianceRule'

interface CreateMaturityComplianceDrawerProps {
  domain: string
  groupId: number
  isVisible: boolean
  onClose: () => void
  onSuccess: () => void
}

export const CreateMaturityComplianceRuleDrawer = ({
  domain,
  groupId,
  isVisible,
  onClose,
  onSuccess,
}: CreateMaturityComplianceDrawerProps) => (
  <Drawer
    title="Create Maturity Compliance Rule"
    placement="right"
    open={isVisible}
    onClose={onClose}
    width={drawerAndModalWidth}
    destroyOnClose
  >
    <CreateMaturityCompliance domain={domain} groupId={groupId} onSuccess={onSuccess} />
  </Drawer>
)
